// Mock data for Cosmos Landing Page

export const heroData = {
  headline: "Cosmos Builds AI-Powered SaaS, Full-Stack Apps & Websites",
  subheadline: "Turn your ideas into intelligent, working solutions",
  emailLink: "mailto:foundercosmos0@gmail.com",
  whatsappLink: "https://wa.me/33745339744"
};

export const servicesData = [
  {
    id: 1,
    title: "AI-Powered SaaS Platforms",
    description: "Dashboards, predictive analytics, and intelligent automation",
    icon: "LayoutDashboard"
  },
  {
    id: 2,
    title: "Intelligent Web Apps",
    description: "Chatbots, recommendation engines, and smart interfaces",
    icon: "Bot"
  },
  {
    id: 3,
    title: "Modern Websites & Landing Pages",
    description: "AI personalization, stunning visuals, and conversion optimization",
    icon: "Globe"
  },
  {
    id: 4,
    title: "AI Automation Tools",
    description: "Workflow automation, reporting, and intelligent scheduling",
    icon: "Zap"
  }
];

export const portfolioData = [
  {
    id: 1,
    title: "AI Gym SaaS",
    description: "Workout plan generation + intelligent booking system",
    tag: "AI Demo Ready"
  },
  {
    id: 2,
    title: "AI Restaurant Ordering App",
    description: "Dish recommendation + predictive staffing",
    tag: "AI Demo Ready"
  },
  {
    id: 3,
    title: "AI Analytics Dashboard",
    description: "KPIs & predictive insights for business intelligence",
    tag: "AI Demo Ready"
  },
  {
    id: 4,
    title: "Voice-Activated Web App",
    description: "Control your SaaS via voice commands",
    tag: "AI Demo Ready"
  }
];

export const whyChooseData = [
  "Full-stack + AI SaaS expert",
  "Intelligent apps that automate business",
  "Modern, scalable, responsive designs",
  "Mobile & SEO-friendly",
  "Fast development & predictive insights"
];

export const howItWorksData = [
  {
    id: 1,
    step: "01",
    title: "Idea & AI Concept",
    description: "Define your vision and AI capabilities",
    icon: "Lightbulb"
  },
  {
    id: 2,
    step: "02",
    title: "Design & AI Architecture",
    description: "Craft the visual and technical blueprint",
    icon: "Palette"
  },
  {
    id: 3,
    step: "03",
    title: "Development",
    description: "Full-stack + AI modules implementation",
    icon: "Code"
  },
  {
    id: 4,
    step: "04",
    title: "Launch & Insights",
    description: "Deploy and monitor with AI analytics",
    icon: "Rocket"
  }
];

export const aiFeaturesData = [
  {
    id: 1,
    title: "Chatbots / GPT Assistants",
    icon: "MessageSquare"
  },
  {
    id: 2,
    title: "Recommendation Engines",
    icon: "Sparkles"
  },
  {
    id: 3,
    title: "Predictive Analytics & Reports",
    icon: "TrendingUp"
  },
  {
    id: 4,
    title: "AI Content Generation",
    icon: "PenTool"
  },
  {
    id: 5,
    title: "Workflow Automation",
    icon: "GitBranch"
  },
  {
    id: 6,
    title: "Voice-Control Interfaces",
    icon: "Mic"
  }
];

export const contactData = {
  title: "Let's Build Your Project Together",
  description: "Reach out today via Email or WhatsApp — I respond fast!",
  emailLink: "mailto:foundercosmos0@gmail.com",
  whatsappLink: "https://wa.me/33745339744"
};

export const footerData = {
  email: "foundercosmos0@gmail.com",
  phone: "+33 745339744",
  instagram: "@cosmos.digital",
  tagline: "Full-Stack, SaaS & AI Apps — Built for Results"
};
